export default "__VITE_ASSET__PMwc_Xxz__"